import { useQuery } from "react-query";
import { Card, CardHeader, CardBody } from "reactstrap";
import apiService from "services/api";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { useResizeDetector } from "react-resize-detector";

import { useEffect, useMemo } from "react";
import { NakedTable } from "components";
import moment from "moment";

const generateRandomColorCode = () => "#" + ((((Math.random() * 0xffffff) << 0) & 0xfefefe) >> 1).toString(16).padStart(6, "0");

const teacherRankingColumns = [
	{ id: "No.", header: "No.", accessor: (row) => row.index },
	{ id: "Teacher", header: "Teacher", accessor: (row) => row.teacherName },
	{ id: "Hours", header: "Hours", accessor: (row) => row.hours },
];

const CustomTooltip = ({ active, payload, label }) => {
	const memoizedPayload = useMemo(() => {
		return payload && payload.length
			? Object.entries(payload[0]?.payload)
					.slice(0, -2)
					.sort(([, hours1], [, hours2]) => hours2 - hours1)
					.map(([teacherName, hours], index) => ({ index: index + 1, teacherName, hours }))
			: [];
	}, [payload]);

	if (active && payload && payload.length) {
		return <NakedTable small={true} columns={teacherRankingColumns} data={memoizedPayload} />;
	}

	return null;
};

const TeachingHoursLineChart = ({ dataset }) => {
	const { width, height, ref } = useResizeDetector();
	useEffect(() => {
		console.log(width);
	}, [width]);
	return (
		<Card>
			<CardHeader>
				<h5 className="title">Teaching Activity</h5>
			</CardHeader>
			<div className="card-body" ref={ref}>
				<LineChart
					width={width - 50}
					height={350}
					data={dataset.cumulativeTeachingHours}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5,
					}}
				>
					<XAxis dataKey="date" />
					<YAxis />
					<Tooltip
						itemSorter={(item) => -item.payload[item.dataKey]}
						offset={100}
						position={{ y: -100 }}
						contentStyle={{ fontSize: "0.9rem" }}
						content={<CustomTooltip />}
					/>
					{dataset.teacherNames.map((teacherName) => (
						<Line
							dataKey={teacherName}
							key={teacherName}
							stroke="#FF6384"
							activeDot={{ r: 8 }}
							className={`${teacherName !== "monthly" && "d-none"}`}
						/>
					))}
				</LineChart>
			</div>
		</Card>
	);
};

const TeachingHourRankingsPage = () => {
	const { data } = useQuery(["Staff", "rankings"], () => apiService.staff.ranking());
	const dataset = useMemo(() => {
		if (!data)
			return {
				teacherNames: [],
				cumulativeTeachingHours: [],
				currentMonthTeachingHours: [],
			};
		const previousMonthDate = moment().subtract(1, "month").format("MMM-YY");
		const teacherNames = Object.keys(Object.values(data)[0]).concat("monthly"); // adding monthly for the placeholder to have the monthly teachiing hours line
		var cumulativeTeachingHours = [];
		var currentMonthTeachingHours = [];

		for (const [date, _teachingHours] of Object.entries(data)) {
			if (date === previousMonthDate) {
				currentMonthTeachingHours = currentMonthTeachingHours.concat(
					Object.entries(_teachingHours)
						.map(([teacherName, hours]) => ({ teacherName, hours }))
						.sort((record1, record2) => record2.hours - record1.hours)
						.map((record, index) => ({ ...record, index: index + 1 }))
				);
			}
			cumulativeTeachingHours.push({
				..._teachingHours,
				date,
				monthly: Object.values(_teachingHours).reduce((prev, accum) => prev + accum, 0),
			});
		}

		// for
		// ideal : [{date: "2022-12-30", "Zi hao": 0, "Khalid": 2}]
		return { teacherNames, cumulativeTeachingHours, currentMonthTeachingHours };
	}, [data]);

	return (
		<div className="content">
			<TeachingHoursLineChart dataset={dataset} />
			<small className="font-weight-bold text-info mb-1 pl-1">Previous Month Top 10 Teaching Hours</small>
			<NakedTable columns={teacherRankingColumns} data={dataset.currentMonthTeachingHours.slice(0, 10)} />
		</div>
	);
};

export default TeachingHourRankingsPage;
